module.exports = __webpack_public_path__ + "img/block_bg01_h5.98cc62d1.webp";